<template>
  <router-link :to="link" class="nu">
    <article class="card hover-brighter bs">
      <div class="card-image">
        <figure class="image" :class="[css ? css : 'is-16by9']">
          <transition name="fade">
            <img
              v-show="image && ready"
              class="mini-rounded custom-img"
              :src="`${image}`"
              @load="
                ready = true;
                $emit('ready');
              "
              :alt="title"
            />
          </transition>
        </figure>
      </div>
      <div
        class="card-content"
        :class="{
          'hidden is-overlay': hidden,
          'is-overlay': $slots.default,
        }"
      >
        <div v-if="!$slots.default">
          <span
            v-if="title"
            :class="{
              'tag project has-text-white': hidden,
              'title is-size-5': !hidden,
            }"
            >{{ title }}</span
          >
          <br />
          <span
            v-if="friendlySubtitle && !hidden"
            :class="{
              'subtitle is-size-6 has-text-grey': !hidden,
              'is-size-6 has-text-grey subtitle has-background-white': hidden,
            }"
            >{{ subtitle }}</span
          >
        </div>

        <slot v-else></slot>
      </div>
    </article>
  </router-link>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

.custom-img {
  object-fit: cover;
}
</style>

<script>
export default {
  props: ["title", "image", "link", "hidden", "subtitle", "css"],
  computed: {
    friendlySubtitle() {
      if (this.subtitle && this.subtitle.toLowerCase() !== "text saknas")
        return this.subtitle;

      return "";
    },
  },
  data() {
    return { ready: false };
  },
  mounted() {},
  methods: {},
};
</script>
